module.exports = __webpack_public_path__ + "static/img/app-logo.ebd497fc.png";